import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '../../../../1-primative';
import { TranslatableTextField } from '../../../../2-component';
import { CreateNewModal } from '../../../../3-pattern';
import { getBackendLanguage } from '../../../../../assets/i18n/config';
import { TranslatedString } from '../../../../../interfaces';

const CREATE_HOME_PAGE_CONFIGURATION = gql`
  mutation createHomePageConfiguration($input: CreateHomePageConfigurationInput!) {
    createHomePageConfiguration(input: $input) {
      homePageConfiguration {
        id
      }
    }
  }
`;

const NewHomePageConfiguration = ({ afterCreate, defaultOrg }: { afterCreate: () => void, defaultOrg?: string }) => {
  const { t } = useTranslation(['settings', 'homePageConfiguration']);
  const [homePageConfiguration, setHomePageConfiguration] = useState({
    translatedName: { en: '', fr: '' } as TranslatedString,
    organizationId: defaultOrg ?? '',
    widgets: [],
  });

  const [createHomePageConfiguration, { loading }] = useMutation(CREATE_HOME_PAGE_CONFIGURATION, {
    variables: {
      input: homePageConfiguration,
    },
  });

  const create = async (event: any) => {
    await createHomePageConfiguration();
    afterCreate();
  };

  const disabled = !homePageConfiguration.translatedName.en || !homePageConfiguration.organizationId;

  return (
    <CreateNewModal
      loading={loading}
      disabled={disabled}
      title={t('homePageConfiguration:configurationModal.title')}
      onSubmit={create}
      maxWidth='sm'
    >
      <Box display='flex' flexDirection='column' gap={2}>
        <TranslatableTextField
          fullWidth
          label={t('homePageConfiguration:configurationModal.name')}
          value={homePageConfiguration.translatedName}
          onChange={(value: TranslatedString) => setHomePageConfiguration({ ...homePageConfiguration, translatedName: value })}
          fallbackLanguage={getBackendLanguage()}
          testId='home-page-configuration-name'
        />
      </Box>
    </CreateNewModal>
  );
};

export default NewHomePageConfiguration;
